// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__i1Qnb","footerText":"Footer_footerText__6-xJr"};